import React from "react";
import { Box, BoxProps, Typography } from "@mui/material";

interface CompactListSurfaceProps extends BoxProps {
  emptyMessage?: string;
  isEmpty?: boolean;
}

export const CompactListSurface: React.FC<CompactListSurfaceProps> = ({
  emptyMessage = "No items found",
  isEmpty = false,
  children,
  sx,
  ...rest
}) => {
  return (
    <Box
      sx={[
        {
          flex: 1,
          minHeight: 180,
          maxHeight: "var(--result-surface-max-height)",
          borderRadius: "var(--result-surface-radius)",
          border: "1px solid var(--result-surface-border)",
          backgroundColor: "var(--result-surface-bg)",
          overflowY: "auto",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {isEmpty ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            px: "var(--metadata-panel-padding)",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {emptyMessage}
          </Typography>
        </Box>
      ) : (
        children
      )}
    </Box>
  );
};
